type NavigationApi = {
  currentEntry?: { index: number } | null;
  entries?: () => unknown[];
};

// The visitor is coming back to a page they left, as opposed to a new navigation into it.
// Wix sites navigate between pages without reloading the document, so a browser back
// from checkout shows up only in the Navigation API: the current history entry is no
// longer the last one. A full-document back/forward or reload is in the timing entry.
export const isReturningNavigation = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const navigation = (window as { navigation?: NavigationApi }).navigation;
  const currentIndex = navigation?.currentEntry?.index;
  const entries = navigation?.entries?.();
  if (
    typeof currentIndex === 'number' &&
    entries &&
    currentIndex < entries.length - 1
  ) {
    return true;
  }
  // Without the Navigation API (Firefox, Safari) an in-site back reads as `navigate`
  // here and the participants are not restored; only a full-document back or reload is.
  const [timing] = window.performance?.getEntriesByType?.('navigation') ?? [];
  const type = (timing as PerformanceNavigationTiming | undefined)?.type;
  return type === 'back_forward' || type === 'reload';
};
